import styled from 'styled-components';

export const Table = styled.section`
  margin-right: -16px;
  word-wrap: break-word;
`;
